import i18n from "@/i18n/index.ts";
export default class DataNexiCharge {
}
DataNexiCharge.Breadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/shop/nexi-addebiti",
        text: i18n.t("nexi_charge.title"),
        disabled: true,
    },
];
DataNexiCharge.BreadcrumbsNew = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/shop/nexi-addebiti",
        exact: true,
        text: i18n.t("nexi_charge.title"),
    },
    {
        text: i18n.t("nexi_charge.new_charge"),
        disabled: true,
    },
];
